var version = {
    "name":      "dativery",
    "buildDateCode": "20251211-202246",
    "buildDate": "Thu Dec 11 2025 20:22:46 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251211-202246",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;